import { ThemeUICSSObject, responsive } from '@apia/theme';
/* IMPORT HERE */

const tasklist: ThemeUICSSObject = {
  '.tabsList': {
    display: 'table',
  },
  '.responsiveTable__wrapper': {
    '.responsiveTable__table': {
      tbody: {
        'tr.isAdquired': {
          color: 'acquiredColor',
        },
        'tr.non-selectable ': {
          color: 'acquiredColorDisabled',
        },

        '.priority': {
          svg: {
            mt: '5px',
            ml: 3,
          },
        },
      },
      '.pro_inst_warn_date': {
        color: (theme) =>
          theme.palette.darkenColor(theme.palette.warning.main, 45),
        fontWeight: 'bold',
      },
      '.pro_inst_overdue_date': {
        color: 'palette.error.main',
        fontWeight: 'bold',
      },
      '.pro_ele_inst_warn_date': {
        color: (theme) =>
          theme.palette.darkenColor(theme.palette.warning.main, 45),
        fontWeight: 'bold',
      },
      '.pro_ele_inst_overdue_date': {
        color: 'palette.error.main',
        fontWeight: 'bold',
      },
    },
    td: {
      "img[alt='Adquirida']": {
        ml: 4,
      },
    },
  },

  '.responsiveTable__accordionElement__toggler': {
    display: 'flex',
    alignItems: 'center',
    gap: 3,
    '.accordionElement__toggler__button': {
      p: 0,
    },
    '.accordion__middle__content': {
      display: 'inline-flex',
      flexDirection: responsive({ 0: 'column', 2: 'row' }),
      width: 'inherit',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
    '.accordion__button__checkbox__wrapper, .accordion__left__icons,  .accordion__right__icons':
      {
        display: 'inline-flex',
        alignItems: 'center',
        flexShrink: 0,
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',

        '&.accordion__label': {
          flexShrink: 1,
          flexBasis: '100%',
        },
      },
  },
  '.htmlCell__tasklist': {
    display: 'flex',
  },
  '.accordion__left__icons': {
    gap: 2,
    height: '20px',
  },
  '.accordionElement__toggler__label': {
    display: 'block',
    alignItems: 'center',
    flexShrink: 0,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    fontWeight: 'normal',
    pl: 2,
  },

  '.priority_container__accordion': {
    display: 'inline-block !important',
  },

  '.checkbox': {
    display: 'contents',
  },
  '.responsiveTable__accordion': {
    'section.locked.isAdquired': {
      '.responsiveTable__accordionElement__toggler': {
        h3: {
          color: 'acquiredColorDisabled',
        },
        backgroundColor: 'palette.gray.850',
      },
    },
    'section.locked.isAdquired:hover': {
      '.responsiveTable__accordionElement__toggler': {
        h3: {
          color: 'acquiredColorDisabled',
        },
      },
    },

    'section.isAdquired': {
      '.responsiveTable__accordionElement__toggler': {
        h3: {
          color: 'acquiredColor',
        },
      },
      '.responsiveTable__accordionElement__toggler:hover': {
        h3: {
          color: 'palette.common.white',
        },
      },
    },
    'section.isReady': {
      '.responsiveTable__accordionElement__toggler': {
        h3: {
          color: 'palette.common.black',
        },
      },
      '.responsiveTable__accordionElement__toggler:hover': {
        h3: {
          color: 'palette.common.white',
        },
      },
    },
    'section.pro_inst_warn_date__row > div': {
      color: (theme) =>
        theme.palette.darkenColor(theme.palette.warning.main, 45),
      fontWeight: 'bold',
    },
    'section.pro_inst_overdue_date__row > div': {
      color: 'palette.error.main',
      fontWeight: 'bold',
    },
    'section.pro_ele_inst_warn_date__row > div': {
      color: (theme) =>
        theme.palette.darkenColor(theme.palette.warning.main, 45),
      fontWeight: 'bold',
    },
    'section.pro_ele_inst_overdue_date__row > div': {
      color: 'palette.error.main',
      fontWeight: 'bold',
    },
    '.responsiveTable__accordionElement__column': {
      display: 'block',
      flexDirection: 'row',
      gap: 2,
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
    },
  },
};

export default tasklist;
